'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import '@/app/marketing.css'

interface MarketingLayoutProps {
  children: React.ReactNode
}

export function MarketingLayout({ children }: MarketingLayoutProps) {
  const pathname = usePathname()

  return (
    <div className="marketing-page">
      <nav className="marketing-nav">
        <div className="container">
          <Link href="/" className="logo">Cohera</Link>
          <div className="nav-links">
            <Link href="/how-it-works" className={pathname === '/how-it-works' ? 'active' : ''}>How It Works</Link>
            <Link href="/use-cases" className={pathname === '/use-cases' ? 'active' : ''}>Use Cases</Link>
            <Link href="/contact" className={`nav-cta ${pathname === '/contact' ? 'active' : ''}`}>Talk to Us</Link>
          </div>
        </div>
      </nav>

      <main>{children}</main>

      <footer className="marketing-footer">
        <div className="container">
          <div className="footer-logo">Cohera</div>
        </div>
      </footer>
    </div>
  )
}
